import { useContext } from "react";
import { FieldProps } from "react-admin";
import TimeField from "../../common/data-grid-fields/TimeField";
import { HosTimers } from "../hosUtils";
import { HosInfoContext } from "./HosInfoContext";

interface Props extends FieldProps {
  field: (record: HosTimers) => number;
  label?: string;
}

export const HosInfoField = ({ field, ...rest }: Props) => {
  const { data } = useContext(HosInfoContext);
  const { record } = rest;
  if (!record?.id) {
    return null;
  }

  const hosData = data.get(record.id);
  if (!hosData) {
    return null;
  }

  const fieldData = field(hosData);

  return (
    <TimeField
      {...rest}
      record={{ id: record.id, data: fieldData }}
      source="data"
      inputType="minutes"
      outputType="short"
      sortable
    />
  );
};
